import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  RequestStatusMap,
  RequestStatusType,
} from 'api/resource-request/types';
import { StatusGroup } from 'api/tasks';
import { StatusIndicatorIcon } from 'components/molecules/status-indicator';

const RequestStatusStyled = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  .request-status {
    display: flex;
    align-items: center;
    gap: var(--spacing-02);
  }
`;

interface RequestStatusProps {
  resourceRequestStatus: RequestStatusType;
}

const REQUEST_STATUS_MAP = {
  [RequestStatusMap.Approved]: {
    statusGroup: StatusGroup.Completed,
    statusText: 'Approved',
  },
  [RequestStatusMap.Blocked]: {
    statusGroup: StatusGroup.Blocked,
    statusText: 'Blocked',
  },
} as const;
const DEFAULT_STATUS = {
  statusGroup: StatusGroup.Todo,
  statusText: 'Todo',
} as const;

export const RequestStatus: React.FC<RequestStatusProps> = ({
  resourceRequestStatus,
}) => {
  const {
    statusGroup,
    statusText,
  }: {
    statusGroup: StatusGroup;
    statusText: string;
  } = useMemo(
    () => REQUEST_STATUS_MAP[resourceRequestStatus] ?? DEFAULT_STATUS,
    [resourceRequestStatus],
  );

  return (
    <RequestStatusStyled>
      <StatusIndicatorIcon group={statusGroup} />
      <span title={statusText}>{statusText}</span>
    </RequestStatusStyled>
  );
};
